import { z } from 'zod';

export const passwordSchema = z
  .string()
  .min(10, 'Password must be at least 10 characters')
  .max(200, 'Password too long')
  .refine((value) => /[a-zA-Z]/.test(value) && /[0-9]/.test(value), {
    message: 'Password must contain at least one letter and one number',
  });

export const emailSchema = z
  .string()
  .email('Invalid email address')
  .max(254)
  .transform((value) => value.toLowerCase().trim());

export const localeSchema = z.enum(['sk', 'cs']);

export const signupSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  name: z.string().min(1).max(120),
  locale: localeSchema.default('sk'),
  marketing_consent: z.boolean().default(false),
});

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1).max(200),
});

export const passwordResetRequestSchema = z.object({
  email: emailSchema,
});

export const passwordResetConfirmSchema = z.object({
  token: z.string().min(32).max(128),
  newPassword: passwordSchema,
});

export const emailVerifySchema = z.object({
  token: z.string().min(32).max(128),
});

export const updateProfileSchema = z.object({
  name: z.string().min(1).max(120).optional(),
  locale: localeSchema.optional(),
  marketing_consent: z.boolean().optional(),
});

export type SignupInput = z.infer<typeof signupSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
export type PasswordResetRequestInput = z.infer<typeof passwordResetRequestSchema>;
export type PasswordResetConfirmInput = z.infer<typeof passwordResetConfirmSchema>;
export type EmailVerifyInput = z.infer<typeof emailVerifySchema>;
export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;
